namespace $.$$ {
	
	const { rem, px } = $mol_style_unit
	
	$mol_style_define( $shm_hitalama_textbook, {
		
		Toc_page: {
			flex: {
				basis: '20rem',
				grow: 0,
			},
		},
		
		Text_page: {
			flex: {
				basis: '48rem',
				grow: 1,
			},
		},
		
		Toc: {
			align: {
				self: 'stretch',
			},
		},
		
		Toc_expand: {
			position: 'absolute',
			zIndex: $mol_layer.float,
			margin: {
				left: rem( -.75 ),
			},
		},
		
		Toc_row: {
			alignItems: 'flex-start',
		},
		
		Toc_link: {
			flex: {
				grow: 1,
				shrink: 1,
			},
		},
		
		Toc_children: {
			margin: {
				left: rem( .75 ),
				bottom: rem( .75 ),
			},
			padding: {
				left: rem( .75 ),
			},
			box: {
				shadow: [{
					inset: true,
					x: px( 1 ),
					y: 0,
					blur: 0,
					spread: 0,
					color: $mol_theme.line,
				}],
			},
		},
		
		Text: {
			padding: $mol_gap.block,
			flex: {
				grow: 1,
			},
		},
		
	} )
	
}
